<template>
	<div class="questions-page elevation-0">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null" class="d-flex">
			<div style="width: 100%" class="d-flex flex-column">
				<FilterChipButton
					v-if="chipsList.length"
					:isButtonActive="isButtonActive"
					:chipsList="chipsList"
					:clearFilter="clearFilter"
					@handleChipClick="handleChipClick"
				/>
				<div v-if="filterModalIsVisible">
					<FilterModal
						:filterModalIsVisible="filterModalIsVisible"
						:currentModalFilter="currentModalFilter"
						:currentModalLabel="currentModalLabel"
						:selectedChips="selectedChips"
						:filters="filters"
						:dateError="date.error"
						:dateOption="date.option"
						:dateRange="date.selectedRange"
						@closeModal="closeModal"
						@applySelection="applySelection"
						@setItem="setItem"
					/>
				</div>
				<v-skeleton-loader v-if="isLoading" type="card" v-bind="attrs" />

				<div v-if="!isLoading && this.sessionQuestions.length === 0" class="mt-5">
					<NewsFeedEmpty
						title="There are no questions now."
						description="Add your question."
					/>
				</div>

				<div class="mt-4" v-if="!isLoading && this.sessionQuestions">
					<div v-for="question in questions" :key="question.qna_question_id">
						<QuestionCard @updateList="updateList" :question="question" />
					</div>
				</div>

				<div
					class="d-flex my-9 justify-center questions-page__pagination"
					v-if="!isLoading && sessionQuestions && sessionQuestions.length > 0"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.sessionQuestionsMeta.pageCount"
						v-on:pageChange="onPageChange"
					/>
				</div>

				<div v-if="addQuestionModalIsOpen">
					<AddSessionQuestionModal
						:show="addQuestionModalIsOpen"
						:isQuestionsPage="true"
						v-on:closeModal="toggleQuestionModal"
						:profile="currentUser"
						@updateList="updateList"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AddSessionQuestionModal from '@/components/Modals/AddSessionQuestionModal.vue'
import Avatar from '@/components/Avatar.vue'
import Pagination from '@/components/Pagination.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import PageBlocked from '@/components/PageBlocked'
import QuestionCard from '@/components/Event/QuestionCard.vue'
import Block from '@/mixins/Block.js'
import Filter from '@/mixins/Filter.js'
import { mapActions, mapGetters } from 'vuex'
import { EventBus } from '@/services/event-bus'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'

export default {
	mixins: [Block, Filter],
	components: {
		FilterModal,
		FilterChipButton,
		AddSessionQuestionModal,
		Pagination,
		NewsFeedEmpty,
		PageBlocked,
		QuestionCard,
		Avatar,
	},
	data() {
		return {
			addQuestionModalIsOpen: false,
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			pageBlockedName: 'events',
		}
	},
	methods: {
		...mapActions('event', [
			'getSessionQuestions',
			'upvoteSessionQuestion',
			'deleteUpvoteSessionQuestion',
		]),
		...mapActions('app', ['setPageTitle']),
		async updateList() {
			await this.getSessionQuestions(this.requestQuery)
		},

		toggleQuestionModal() {
			if (!this.isLoading) {
				this.addQuestionModalIsOpen = !this.addQuestionModalIsOpen
			}
		},
	},
	computed: {
		...mapGetters('event', [
			'isLoading',
			'sessionQuestions',
			'sessionQuestionsMeta',
			'deleteQuestionLoading',
		]),
		...mapGetters('auth', ['profile']),
		currentUser() {
			return this.profile
		},
		questions() {
			if (!Array.isArray(this.sessionQuestions)) return []

			return this.sessionQuestions
				.map(
					(item) =>
						item?.questionList?.find((q) => q.block_name === 'questionInfo')
							?.block_data || null
				)
				.filter(Boolean)
		},
	},
	mounted() {
		this.setPageTitle('Q&A')
	},
	beforeDestroy() {
		this.setPageTitle('')
		EventBus.$off('openQuestionModal', this.toggleQuestionModal)
	},
	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.getSessionQuestions(this.requestQuery)
			EventBus.$on('openQuestionModal', this.toggleQuestionModal)
		}
	},
}
</script>

<style lang="scss">
</style>
